import React, {useEffect, useState} from 'react'
//import LogoProyecto from './logoProyecto.component'

interface SelectionBtnsProps {
    selectionData: any,
    handleMenuSelection: any,
    dataColors: any,
    selectionBtnName: string
    logo: any,
    logo_constructora: any
} 
declare const window: any;

const SelectionBtns = ({selectionData, handleMenuSelection, dataColors, selectionBtnName, logo, logo_constructora}: SelectionBtnsProps) => {

    const [isBtnHoverIndex, setBtnHoverIndex] = useState(-1)

    const changeIconColor = (payload: string) => {
        var svgObj: any = document.getElementById('selected-btn');
        if(svgObj){
            var svgDoc = svgObj.contentDocument
            var paths = svgDoc.querySelectorAll('path')
            paths.forEach((path: any) => {
                path.setAttribute('fill',dataColors.secondary_text)
            })
        }
    }

    useEffect(() => {
        var svgObj: any = document.querySelectorAll('#unselected-btn');
        if(svgObj){
            svgObj.forEach((obj: any) => {
                var svgDoc = obj.contentDocument
                var paths = svgDoc.querySelectorAll('path')
                paths.forEach((path: any) => {
                    path.setAttribute('fill','#000')
                })
            })
        }
        var svgObj2: any = document.getElementById('selected-btn');
        if(svgObj2){
            var svgDoc = svgObj2.contentDocument
            var paths = svgDoc.querySelectorAll('path')
            paths.forEach((path: any) => {
                path.setAttribute('fill',dataColors.secondary_text)
            })
        }
    }, [selectionBtnName, dataColors])
    
    return(
        <div className='selection-btn-container'>
             {/* <LogoProyecto
                    logo={logo}
                    handleMenuSelection = {handleMenuSelection}
                /> */}
                {/* <div
                    className='individual-selection-img' 
                >
                    <img src={(window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/")+logo_constructora} alt=""/>
                </div> */}
                <div
                    className='individual-selection-img' 
                >
                    <img src={(window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/")+logo} alt=""/>
                </div>
        {
            selectionData ? selectionData.map((btn: any, index: number) => 
                <div 
                    className='individual-selection-btn' 
                    key={btn.name + index} 
                    onClick = {selectionBtnName === btn.slug ?  
                    () => {
                        handleMenuSelection("")
                        changeIconColor(btn.slug)
                    }:
                    () => {
                        handleMenuSelection(btn.slug)
                        setTimeout(() => {
                            changeIconColor(btn.slug)
                        }, 100) 
                    }}
                    onMouseEnter = {() => {setBtnHoverIndex(index)}}
                    onMouseLeave = {() => {setBtnHoverIndex(-1)}}
                    style = {{
                        backgroundColor: 
                            isBtnHoverIndex === index ? 
                            dataColors.secondary_buttons : selectionBtnName === btn.slug ? 
                            dataColors.main_buttons:"",
                        transition: "all 0.2s ease-in-out"
                    }}
                >
                    <object 
                    type="image/svg+xml" 
                    data={btn.icono} 
                    className="svg-img" 
                    id = {selectionBtnName === btn.slug ? 'selected-btn':'unselected-btn'}
                    style={{cursor: 'pointer', pointerEvents: 'none'}}
                    onClick = {selectionBtnName === btn.slug ?  
                        () => {
                            handleMenuSelection("")
                            changeIconColor(btn.slug)
                        }:
                        () => {
                            handleMenuSelection(btn.slug)
                            setTimeout(() => {
                                changeIconColor(btn.slug)
                            }, 100) 
                        }}
                    >.</object>
                    {/*<img src={btn.icono} alt="" />*/}
                    <div 
                        className='selection-btn-name' 
                        style={{
                            color: selectionBtnName === btn.slug ? '#fff': '#000'
                        }}
                    >
                        {btn.name}
                    </div>
                </div>
            ): null
        }
    </div>
    )
}

export default SelectionBtns